import { ActualOperation } from '../types/interfaces';

export const ActualJobTemplate: ActualOperation = {
  id: '',
  key: '',
  operation: { key: '', label: '' },
  volume: '',
  measure: { key: '', label: '' },
  employees: [],
  comment: '',
  generatedID: true,
  changed: false
};
